import { render } from "./FormClient.vue?vue&type=template&id=2a92fdb6&scoped=true"
import script from "./FormClient.vue?vue&type=script&lang=js"
export * from "./FormClient.vue?vue&type=script&lang=js"

import "./FormClient.vue?vue&type=style&index=0&id=2a92fdb6&scoped=true&lang=scss"

import exportComponent from "d:\\source\\Mobaxe.Docs.App\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a92fdb6"]])

export default __exports__